import { render } from "./ContentComponent.vue?vue&type=template&id=2d897792&scoped=true"
import script from "./ContentComponent.vue?vue&type=script&lang=js"
export * from "./ContentComponent.vue?vue&type=script&lang=js"

import "./ContentComponent.vue?vue&type=style&index=0&id=2d897792&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d897792"]])

export default __exports__